import styles from "./css/AboutGarudaBackgroundImage.module.css";

export interface AboutGarudaBackgroundImageProps {
  children: React.ReactNode;
}

export default function AboutGarudaBackgroundImage({
  children,
}: AboutGarudaBackgroundImageProps) {
  return (
    <div className={styles.container}>
      <div className={styles.childContainer}>
        {children}
      </div>
    </div>
  );
}
